"use strict";

angular.module("vendor")
.controller("SectionOrderLog", function($rootScope, $stateParams, $state, UserService) {
    var order_id = $stateParams.order;

    if (order_id) {

        var unregister = $rootScope.$on("UserUpdated", function() {
            unregister();

            // If the user is loggedin, redirect to the order detail
            if (UserService.isLoggedIn()) {
                $state.go("orderDetails", {
                    id: order_id,
                    referer: "email"
                });
            }
            else {
                $state.go("login", {
                    order: order_id,
                    state: "orderDetails",
                    referer: "email"
                });
            }

        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/order/order-log.controller.js
// module id = 989
// module chunks = 0